import { register } from 'register-service-worker'

// The ready(), registered(), cached(), updatefound() and updated()
// events passes a ServiceWorkerRegistration instance in their arguments.
// ServiceWorkerRegistration: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration

register(process.env.SERVICE_WORKER_FILE, {
  // The registrationOptions object will be passed as the second argument
  // to ServiceWorkerContainer.register()
  // https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register#Parameter

  // registrationOptions: { scope: './' }, hanged?

  ready () {
    if (process.env.DEV) {
      console.log('[SW] App is being served from cache by a service worker.')
    }
  },

  registered (registration) {
    if (process.env.DEV) {
      console.log('[SW] Service worker has been registered.')
    }
    setInterval(() => {
      registration.update()
    }, 1 * 60 * 1000) // check for new version each period [ 1 min ]
  },

  cached (/* registration */) {
    if (process.env.DEV) {
      console.log('[SW] Content has been cached for offline use.')
    }
  },

  updatefound (registration) {
    if (process.env.DEV) {
      console.log('[SW] New content is downloading.')
    }
  },

  updated (registration) {
    if (process.env.DEV) {
      console.log('[SW] New content is available; please refresh.')
    }
    document.dispatchEvent(
      new CustomEvent('serviceWorkerUpdateEvent', { detail: registration })
    )
  },

  offline () {
    if (process.env.DEV) {
      console.log('[SW] No internet connection found. App is running in offline mode.')
    }
  },

  error (err) {
    if (process.env.DEV) {
      console.error('[SW] Error during service worker registration:', err)
    }
  }
})
